import auth0 from 'auth0-js';

import SITE_PATHS from '../config/sitePaths';
import {
  SMARTCONSENT_AUDIENCE,
  SMARTCONSENT_CLIENT_ID,
  SMARTCONSENT_DOMAIN,
  SMARTCONSENT_AUTH_SCOPE,
  SMARTCONSENT_AUTH_CONNECTION_TYPE,
} from '../config/configuration';

import { buildURL } from '../utils/urlHelpers';

export default class Auth0 {
  constructor(encodedURL) {
    this.stateData = encodedURL;
  }

  AUTH_RESPONSE_TYPE = 'id_token';

  auth0 = new auth0.WebAuth({
    clientID: SMARTCONSENT_CLIENT_ID,
    domain: SMARTCONSENT_DOMAIN,
    redirectUri: buildURL(SITE_PATHS.SIGNIN_CALLBACK),
    scope: SMARTCONSENT_AUTH_SCOPE,
    audience: SMARTCONSENT_AUDIENCE,
    responseType: this.AUTH_RESPONSE_TYPE,
  });

  authorize() {
    const authParams = {
      connection: SMARTCONSENT_AUTH_CONNECTION_TYPE,
      responseType: this.AUTH_RESPONSE_TYPE,
    };

    if (this.stateData) authParams.state = this.stateData;

    this.auth0.authorize(authParams);
  }
}
